export const ACCEPTED_FILE_TYPES = {
  PNG: "image/png",
  JPEG: "image/jpeg",
  SVG: "image/svg+xml",
};

export const MAX_FILE_SIZE_KB = 100;
